import { render } from "./App.vue?vue&type=template&id=5f4eae96"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5f4eae96&lang=scss"
import "./App.vue?vue&type=style&index=1&id=5f4eae96&lang=scss"

import exportComponent from "/root/workspace/public_sso_ZgiA/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__